import { Icons } from "atoms/constants/icons";
import CultureResources from "utilities/interfaces/culture-resources";

export enum NotebookPageContentBlock {
    Text = 1,
    CodeReference = 2,
    Checklist = 3,
    Image = 4,
}

export const NotebookPageContentBlockCultureCode: Record<
    NotebookPageContentBlock,
    keyof CultureResources
> = {
    [NotebookPageContentBlock.Text]: "text",
    [NotebookPageContentBlock.CodeReference]: "codeReference",
    [NotebookPageContentBlock.Checklist]: "checklist",
    [NotebookPageContentBlock.Image]: "image",
};

export const NotebookPageContentBlockIcon: Record<
    NotebookPageContentBlock,
    Icons
> = {
    [NotebookPageContentBlock.Text]: Icons.TextBlock,
    [NotebookPageContentBlock.CodeReference]: Icons.CodeReference,
    [NotebookPageContentBlock.Checklist]: Icons.Checklist,
    [NotebookPageContentBlock.Image]: Icons.Image,
};
